import { d as debounce } from './debounce-CFN_LA0O.js';

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.buttons = this.querySelectorAll('button');
    this.min = this.input.min;
    this.max = this.input.max;

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => this.handleStep(event.currentTarget.name));
    });

    this.input.addEventListener('change', () => {
      this.constrainAndUpdateInput(this.input.value);
      this.publishEvents();
    });

    this.intent = this.dataset.intent;
    this.productId = Number(this.dataset.productId) || null;
  }

  /**
   * Handle the step up or step down of the quantity
   * @param {string} type - The type of step to be taken
   */
  handleStep(type) {
    const value = parseInt(this.input.value);
    const step = parseInt(this.input.step) || 1;
    const newValue = type === 'minus' ? Math.max(value - step, 0) : value + step;
    const updatedValue = this.constrainAndUpdateInput(newValue);

    if (parseInt(updatedValue) !== parseInt(value)) {
      this.publishEvents();
    }
  }

  /**
   * Update the quantity in the cart
   */
  publishEvents = debounce(
    () => {
      switch (this.intent) {
        case 'cart:change':
          publish('cart:change', {
            line: this.dataset.itemIndex,
            quantity: this.input.value,
            productId: this.productId,
          });
          break;
        case 'quantity:change':
          publish('quantity:change', {
            quantity: this.input.value,
          });
          break;
      }
    },
    this.dataset.debounce === 'true' ? 300 : 0
  );

  /**
   * Constrain and update the input.
   * @param {number} newValue - The new value.
   * @returns {number} The constrained value.
   */
  constrainAndUpdateInput(newValue) {
    this.input.value = newValue;

    if (newValue >= this.max && this.max !== '') {
      window.toast.error(
        window.toast_translations.product.quantity_error_max.replace('{{ max }}', this.max)
      );
      this.input.value = this.max;
    } else if (newValue <= this.min) this.input.value = this.min;

    return this.input.value;
  }
}

customElements.define('quantity-input', QuantityInput);
